import { useConversation } from "@elevenlabs/react";
export default function VoiceAssistantCyberLab() {

  const conversation = useConversation({
    agentId: "agent_7201kg3jbv6tfzta3nhqkymb8609"
  });

  const startConversation = async () => {
    await conversation.startSession();
  };

  const endConversation = async () => {
    await conversation.endSession();
  };

  return (
    <div>
<div
  style={{
    position: "fixed",
    bottom: "20px",
    right: "20px",
    width: "220px",
    background: "#fff",
    borderRadius: "15px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
    padding: "15px",
    textAlign: "center"
  }}
>
<div style={{ border: "5px solid green" }}>
  <img
    src="/cyberlab-avatar.png"
    alt="Cyber Lab Assistant"
    width="100"
    height="100"
  />
  <h4 style={{ margin: "5px 0" }}>Cyber Lab Assistant AI</h4>
</div>

  <p style={{ fontSize: "12px", color: "#666" }}>
    Your Cyber Lab Expert Assistant
  </p>

  <button
    onClick={startConversation}
    style={{
      width: "100%",
      marginTop: "10px",
      padding: "8px",
      borderRadius: "8px",
      backgroundColor: "green",
      color: "white",
      border: "none",
      cursor: "pointer"
    }}
  >
    🎤 Talk to Cyber Lab Assistant
  </button>

  <button
    onClick={endConversation}
    style={{
      width: "100%",
      marginTop: "8px",
      padding: "8px",
      borderRadius: "8px",
      backgroundColor: "red",
      color: "white",
      border: "none",
      cursor: "pointer"
    }}
  >
    End Conversation
  </button>
</div>
    </div>
  );
}